module.exports = require("process");


//////////////////
// WEBPACK FOOTER
// external "process"
// module id = 1223
// module chunks = 0